import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { deletePropertyIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDeletePropertyMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, number>({
		mutationFn: processResponse((id: number) => deletePropertyIdV2(id)),
		onSuccess: (_data, id) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.propertyLists(),
			});
			queryClient.removeQueries({ queryKey: PortfolioKeys.propertyDetail(id) });
		},
	});
};
